import React, { useEffect, useState } from "react";
import { CHILD_OVERVIEW_LABELS } from "../ChildtrackingConstant";
import "./index.css";
import dayjs from "dayjs";
import Button from "@components/common/Button";
import { ServiceReportCodeForChild } from "../../Child/ChildServices/NewBorn/NewBornForm/NewBornConstants";
import EyeIcon from './../../../../../assets/svg/eye-view.svg';
import { buttonNames } from "@constants/appConstants";
import ChildImmunizationTable from "./table";
import { InputGroup, Modal } from "react-bootstrap";
import CommonFormFields from "@pages/Forms/CommonFormFields";
import { child_immunization_message } from "@constants/childTrackingConstant";
import { getData, postDataJSON } from "@services/CommonApiService";
import endpoints from "@config/endpoints";
import { RootState } from "@store/reducers";
import { useSelector } from "react-redux";
import { errorLogger } from "@utils/applicationLogUtils";
import { isServiceThroughSession } from "@utils/commonUtils";
import { dateFormate } from "@constants/index";
import { decodeWithKeyAndShift } from "@utils/base64Utils";
import { benef_const } from "@constants/beneficiaryConstant";
import { toast } from "react-toastify";
import { updateChild } from "@store/actions/beneficiaryAction";
import { useDispatch } from "react-redux";
import BadgesComponent from "@components/common/Badges";
import { immunizationData } from "@constants/index";
import { formStateType, formDataType, initObject } from "./ImmunizationTypes";
import { DatePicker } from "antd";
import InfoBar from '@components/common/InfoBars';
import VectorIcon from './../../../../../assets/svg/Vector.svg'
import { UPDATE_CHILD_DETAILS } from "@store/types/beneficiaryTypes";


const ChildImmunization = () => {

    const [showAddReportAEFICard, setShowAddReportAEFICard] = useState<boolean>(false);
    const userId = localStorage.getItem('userId');
    const [modalForm, setModalForm] = useState<formStateType>(initObject);
    const [modalFormData, setModalFormData] = useState<formDataType>(immunizationData);
    const [disableReportAefi, setDisableReportAefi] = useState<boolean>(false)
    const eventExution = useSelector((state: RootState) => state.eventExution);
    const [immunizationDates, setImmunizationDates] = useState<any>([])
    const [childDeathDeatils, setChildDeathDeatils] = useState<any>()
    const [reportAefiData, setReportAefiData] = useState<any>([]);
    const vhndDetails = isServiceThroughSession(eventExution);
    const [viewReportedComplication, setViewReportedComplication] = useState<boolean>(false)
    const userDetail = JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userDetails')));
    const childDetails = useSelector((state: RootState) => state.beneficiary.childDetails);
    const vaccineDateUpdated = useSelector((state: RootState) => state.beneficiary.vaccineDateUpdated);
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const dates = await getData<any>(`${endpoints.completedImmunizations}/${childDetails?.benef_id}`);
                setImmunizationDates(dates)
                const serviceDateAvailable = dates?.data?.some((item: any) =>
                    benef_const.immunizationVaccinations.includes(item.service_code) && !!item.service_date
                );
                const reportAefiItem = dates?.data?.filter((item: any) => item.service_code === benef_const.aefiReportedCode)
                .sort((a: any, b: any) => new Date(b.visit_date).getTime() - new Date(a.visit_date).getTime())
                if(reportAefiItem.length !==0){
                    setModalFormData((prevState: any) => ({
                    ...prevState,
                    reportedDate: {
                        ...prevState.reportedDate,
                        '#minDate':dayjs(reportAefiItem[0].visit_date).add(1, 'day'),
                    },
                }));
                }
                setReportAefiData(reportAefiItem);
                setDisableReportAefi(!serviceDateAvailable);
                const getAEFIReportedOptions = await postDataJSON<any>(
                    `${endpoints.fetchServiceReportForChild}`, { reportType: ServiceReportCodeForChild.aefiReported, isImmunization: true }
                );
                const deathDueToAefi = await postDataJSON<any>(
                    `${endpoints.fetchServiceReportForChild}`, { reportType: ServiceReportCodeForChild.deathFollowingAefi, isImmunization: true }
                );

                const deathDetailsRes = await getData<any>(`${endpoints.childDeathDetails(childDetails?.benef_id)}`);
                setChildDeathDeatils(deathDetailsRes.data[0]);

                setModalFormData((prevState: any) => ({
                    ...prevState,
                    deathByAEFI: {
                        ...prevState.deathByAEFI,
                        "#options": deathDueToAefi?.data?.map((key: any) => ({
                            value: key.report_name,
                            label: key.report_name,
                            serviceId: key.service_id,
                            reportId: key.report_id,
                        })),
                    },
                    adverseEffect: {
                        ...prevState.adverseEffect,
                        "#options": getAEFIReportedOptions?.data?.map((key: any) => ({
                            value: key.report_name,
                            label: key.report_name,
                            serviceId: key.service_id,
                            reportId: key.report_id,
                        })),
                    },
                }));
            } catch (error) {
                errorLogger(error)
            }
        };

        if (childDetails?.benef_id) {
            fetchData();
        }
    }, [vaccineDateUpdated]);


    const handleFormChange = (value: any, key: string, id?: any, option?: any, code?: any, field?: formDataType | undefined) => {
        const selectedOption = option?.find((data: any) => data.value === value)

        setModalForm((prevState: any) => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                value: value,
                isError: false,
                message: '',
                id: id,
                code: code,
                reportId: selectedOption?.reportId,
                serviceId: selectedOption?.serviceId,
            },
        }));
        if (key === 'deathByAEFI') {
            if (value === benef_const.yesOption) {
                setModalFormData((prevState: any) => ({
                    ...prevState,
                    ['deathDate']: {
                        ...prevState['deathDate'],
                        '#required': true,
                        '#isDisabled': false,
                    },
                }));
                setModalForm((prevState: any) => ({
                    ...prevState,
                    ['deathDate']: {
                        ...prevState['deathDate'],
                        isDisable: false,
                    },
                }));
            }
            else {
                setModalFormData((prevState: any) => ({
                    ...prevState,
                    ['deathDate']: {
                        ...prevState['deathDate'],
                        '#required': false,
                        '#isDisabled': true,
                    },
                }))
                setModalForm((prevState: any) => ({
                    ...prevState,
                    ['deathDate']: {
                        ...prevState['deathDate'],
                        isDisable: true,
                        value: '',
                        isError: false,
                        message: '',
                        id: '',
                        code: ''
                    },
                }))
            }
        }
    }

    const handleDeathSubmit = async () => {
        let checkError = false;
        if (!modalForm.adverseEffect.value) {
            setModalForm((prevState: any) => ({
                ...prevState,
                adverseEffect: {
                    ...prevState.adverseEffect,
                    isError: true,
                    message: child_immunization_message.errorMessageForAdverseDetails,
                },
            }));
            checkError = true;
        }
        if (!modalForm.deathByAEFI.value) {
            setModalForm((prevState: any) => ({
                ...prevState,
                deathByAEFI: {
                    ...prevState.deathByAEFI,
                    isError: true,
                    message: child_immunization_message.errorMessageFordeathByAEFI,
                },
            }));
            checkError = true;
        }
        if (!modalForm.reportedDate.value) {
            setModalForm((prevState: any) => ({
                ...prevState,
                reportedDate: {
                    ...prevState.reportedDate,
                    isError: true,
                    message: child_immunization_message.errorMessageFordeathDate,
                },
            }));
            checkError = true;
        }
        if (modalForm.deathByAEFI.value===benef_const.yesOption && !modalForm.deathDate.value) {
            setModalForm((prevState: any) => ({
                ...prevState,
                deathDate: {
                    ...prevState.deathDate,
                    isError: true,
                    message: child_immunization_message.errorMessageFordeathDate,
                },
            }));
            checkError = true;
        }
        if (!checkError) {
            const payload = {
                benefId: childDetails?.benef_id,
                dateOfVisit: modalForm?.reportedDate?.value ? dayjs(modalForm?.reportedDate?.value).format(dateFormate.yyyy_mm_dd) : '',
                parentUserId: userId,
                aefiServiceId: modalForm.adverseEffect.serviceId,
                aefiReportId: modalForm.adverseEffect.reportId,
                deathHappened: modalForm.deathByAEFI.value === "Yes" ? true : false,
                dateOfDeath: modalForm.deathDate?.value ? dayjs(modalForm.deathDate.value).format(dateFormate.yyyy_mm_dd) : '',
                moduleCode: "child immunization death",
                facilityId: userDetail?.facility_id,
                healthProviderId: userId,
                mobiliserId: null,
                sessionId: vhndDetails?.sessionId || null
            };

            try {
                const response: any = await postDataJSON(`${endpoints.reportChildDeathUnderImmunization}`, payload);

                if (response?.data?.[0]) {
                    setShowAddReportAEFICard(false);
                    dispatch(updateChild("vaccineDateUpdated", !vaccineDateUpdated));
                    toast.success(benef_const.reportAefi, { position: "top-center" });
                    const resetField = { isError: false, message: "", isDisable: false, value: "", reportId: "", serviceId: "" };
                    setModalForm({ adverseEffect: resetField, deathDate: resetField, deathByAEFI: resetField, reportedDate: resetField });
                    const childResponse = await getData<any>(`${endpoints.childBeneficiaryById}/${childDetails?.benef_id}`);
                    if (childResponse?.data?.[0]) {
                        dispatch({
                            type: UPDATE_CHILD_DETAILS,
                            payload: childResponse.data[0]
                        });
                    }
                } else {
                    throw new Error();
                }
            } catch (error) {
                errorLogger(error)
                toast.error(benef_const.somethingWentWrong, { position: "top-center" });
            }
        }

    }

    return (
        <div className="child-immunization">
            <div className="child-immunization-buttons">                
      {/* this is required for future reference
      
           {!viewReportedComplication && <><Button
                    onClick={() => {
                        setViewReportedComplication(true)
                    }}
                    disabled={reportAefiData.length ===0}
                    id="benf-filter-clear"
                    buttonName={buttonNames.viewReportedComplication}
                    colorType={'primary'}
                    icon={<EyeIcon />}
                    iconPosition={'left'}
                />
                    <Button
                        onClick={() => {
                            setShowAddReportAEFICard(true)
                        }}
                        disabled={
                            disableReportAefi 
                            || childDeathDeatils?.date_of_death
                        }
                        id="benf-filter-clear"
                        buttonName={buttonNames.reportAEFI}
                        colorType={'primary'}
                        icon={''}
                        iconPosition={''}
                    /></>}
              {
                    viewReportedComplication &&
                    <Button
                        onClick={() => {
                            setViewReportedComplication(false)
                        }}
                        disabled={false}
                        id="benf-filter-clear"
                        buttonName={buttonNames.backToImmunizationTable}
                        colorType={'primary'}
                        icon={''}
                        iconPosition={'left'}
                    />
                } */}
            </div>
            {viewReportedComplication ? <>
                <div className="overview-reported-complications-details-container">
                    <BadgesComponent
                        className="over-badge"
                        badgeName="Reported Complications"
                        variant="primary-1"
                        badgeType="case5"
                    />
                    {Array.isArray(reportAefiData) && reportAefiData.length > 0 && (
                        <>
                            {reportAefiData.map((item: any, idx: number) => (
                                <div className="overview-reported-complications-details" key={idx}>
                                    <div>
                                        <label className="overview-reported-complications-details-label">Reported Date</label>
                                        <div className="overview-reported-complications-details-value">
                                            {item?.visit_date ? dayjs(item?.visit_date).format(dateFormate.dd_mm_yyyy) : "-"}
                                        </div>
                                    </div>
                                    <div>
                                        <label className="overview-reported-complications-details-label">Adverse Effect</label>
                                        <div className="overview-reported-complications-details-value">
                                            {item?.service_report || '-'}
                                        </div>
                                    </div>
                                    <div>
                                        <label className="overview-reported-complications-details-label">Death Following AEFI</label>
                                        <div className="overview-reported-complications-details-value">
                                            {(childDeathDeatils?.death_reason_name && idx===0) ? "Yes" : "No"}
                                        </div>
                                    </div>
                                    <div>
                                        <label className="overview-reported-complications-details-label">Date of Death following AEFI</label>
                                        <div className="overview-reported-complications-details-value">
                                            {(childDeathDeatils?.date_of_death && idx===0) ? dayjs(childDeathDeatils?.date_of_death).format(dateFormate.dd_mm_yyyy) : "-"}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </>
                    )}
                </div>

            </> : <> <div className="Immunization-header-container">{CHILD_OVERVIEW_LABELS.IMMUNIZATION_HEADER}</div>
                <ChildImmunizationTable dates={immunizationDates} isDead={childDeathDeatils?.date_of_death} /> </>}
            {showAddReportAEFICard &&
                <div className="modal_gender_beneficiaries">
                    <Modal
                        show={showAddReportAEFICard}
                        onHide={() => {
                            setShowAddReportAEFICard(false);
                            setModalForm(initObject);

                        }}
                        dialogClassName={'beneficiaries-gender-card-modal'}
                        centered={true}
                    >
                        <Modal.Body  >
                            <div>
                                <div className="modal-headings-container">
                                    <span className="modal-heading-title">Complications</span>
                                </div>
                                <form className="immunization_container_health_block">
                                    <CommonFormFields
                                        formData={modalFormData}
                                        formState={modalForm}
                                        handleFormChange={handleFormChange}
                                    />
                                    <div className="lmpDate_wrapper">
                                        <label className="label-name-from-parent" >
                                            Date of Death following AEFI
                                            {modalFormData.deathDate?.['#required'] && !modalForm.deathDate?.isDisable && (
                                                <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                                            )}
                                        </label>
                                        <InputGroup>
                                            <DatePicker
                                                format={dateFormate.dd_mm_yyyy}
                                                title="Date of Death following AEFI"
                                                placeholder={dateFormate.dd_mm_yyyy}
                                                value={modalForm.deathDate?.value ? dayjs(modalForm.deathDate.value) : undefined}
                                                disabled={modalForm.deathDate?.isDisable}
                                                maxDate={modalFormData.deathDate?.['#maxDate'] ? dayjs(modalFormData.deathDate['#maxDate']) : dayjs()}
                                                onChange={(value) => {
                                                    setModalForm((prevState: any) => ({
                                                        ...prevState,
                                                        deathDate: {
                                                            ...prevState.deathDate,
                                                            value: value ? value.format(dateFormate.yyyy_mm_dd) : "",
                                                            isError: false,
                                                            message: "",
                                                        },
                                                    }));
                                                }}
                                                className="dateOfDeath"
                                                popupClassName="date-picker-popup-preg-register"
                                                suffixIcon={<VectorIcon />}
                                                showTime={false}
                                                placement="bottomLeft"
                                                getPopupContainer={(trigger) => trigger.parentElement as HTMLElement}
                                                picker="date"
                                            />
                                        </InputGroup>
                                        <div className="input_field_infoBars">
                                            {modalForm.deathDate?.isError && (
                                                <InfoBar
                                                    variant="danger"
                                                    message={modalForm.deathDate.message}
                                                    className="input_field_class"
                                                />
                                            )}
                                        </div>
                                    </div>
                                </form>
                                <div className="report-aefi-submit">
                                    <Button
                                        onClick={() => handleDeathSubmit()}
                                        disabled={false}
                                        id="report-aefi-submit-button"
                                        buttonName={buttonNames.submit}
                                        colorType={'primary'}
                                        icon={''}
                                        iconPosition={''}
                                    />
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>}
        </div>
    );
};

export default ChildImmunization;
